// supported query strings
export default {
	darkMode: 'darkMode',
	viewKey: 'viewKey',
};
